import { render, staticRenderFns } from "./privacyPolicy.vue?vue&type=template&id=1d6e5dda&scoped=true"
import script from "./privacyPolicy.vue?vue&type=script&lang=js"
export * from "./privacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./privacyPolicy.vue?vue&type=style&index=0&id=1d6e5dda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6e5dda",
  null
  
)

export default component.exports